exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-table {\n  display: table; }\n\n.d-100vh-va-middle {\n  height: 100vh;\n  display: table-cell;\n  vertical-align: middle; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/login/style.css
// module id = ../../../../../src/app/login/style.css
// module chunks = main